import clsx from 'clsx';
import { OpenInNewOutlined } from '@mui/icons-material';

import { SafeLink } from './SafeLink';
export { SafeLink } from './SafeLink';

type LinkProps = {
  url: string;
  title?: string;
  newTab?: boolean;
  className?: string;
  activeClassName?: string;
  defaultClassName?: string;
  label?: React.ReactNode;
  children?: React.ReactNode;

  withIcon?: boolean;
  withDecoration?: boolean;

  onClick?: () => void;
};

export const Link: React.FC<LinkProps> = ({
  url,
  label,
  title,
  newTab,
  children,
  className,
  activeClassName,
  defaultClassName = 'cursor-pointer',

  withIcon = false,
  withDecoration = false,

  onClick,
}) => {
  if (!url) return null;

  return (
    <SafeLink
      isNav
      to={url}
      title={title}
      newTab={newTab}
      onClick={onClick}
      activeClassName={activeClassName}
      className={clsx(
        defaultClassName,

        withDecoration
          ? 'border-b hover:border-main hover:text-main pr-sm border-transparent transition-default'
          : '',
        className
      )}
    >
      {children ?? label}
      {!!withIcon && <OpenInNewOutlined className="ml-xs mb-[0.2em]" />}
    </SafeLink>
  );
};
